import { put, call, select } from 'redux-saga/effects'
import * as types from './types'
import { cleanBusinessLineStrings, cleanFactoidStrings, cleanString, shuffle } from '../../lib/helpers'
import Requests from '../../lib/requests'

function* checkAndGetData() {
  let data
  // if (localStorage.getItem('horizon-data')) {

  //   // @ts-ignore
  //   data = JSON.parse(localStorage.getItem('horizon-data'))

  // } else {
  const res = yield call(Requests.getAllData);

  const factoids = shuffle(res[0].data.map(cleanFactoidStrings))
  const businessLines = res[2].data.map(cleanBusinessLineStrings)
  const classes = res[1].data.map((classItem: any) => ({...classItem, name: cleanString(classItem.name)}))

  data = {
    factoids,
    classes,
    businessLines,
    locations: res[3].data,
    cachedTimestamp: Date.now()
  }

  // localStorage.setItem('horizon-data', JSON.stringify(data))
  // }

  yield put({ type: types.LOAD_DATA_SUCCESS, payload: data })


  // grabs data from localstorage

  // checks cachedTimestamp if certain amount of days has passed, make new call to WP api for data

  // store data back into state.data
}

function* showSnackbar(action: any) {
  let message: string
  if (action.type.includes('DESELECT') || action.type.includes('REMOVE')) {
    message = 'Removed from experience'
  } else {
    message = 'Added to experience'
  }
  yield put({ type: types.OPEN_SNACKBAR, payload: message })
}

function* saveJourney() {
  const viewsSelections = yield select((state: any) => state.views.new.selections)
  localStorage.setItem('viewsSelections', JSON.stringify(viewsSelections))
}

export { checkAndGetData, showSnackbar, saveJourney }



// WEBPACK FOOTER //
// ./src/core/duck/operations.ts